import { takeEvery, all, select, put } from 'redux-saga/effects';
import { REQUEST_INVOICE_FILTER, REQUEST_INVOICES } from './constants';
import { GET_MY } from '../../containers/App/constants';
import { selectInvoiceFilter } from './selectors';

function* requestInvoiceFilter() {
  let filter = yield select(selectInvoiceFilter());

  let offset = filter.offset || 0;
  let limit = filter.limit || 10;
  let text = filter.searchString?.trim() || null;

  let path = `invoice?offset=${offset}&limit=${limit}${text ? `&text=${text}` : ''}`;
  if (filter?.direction) {
    path += `&direction=${filter.direction}`;
  }
  if (filter?.isFinal) {
    path += `&isFinal=${filter?.isFinal}`;
  }

  if (filter?.company) {
    path += `&companyId=${filter.company?.id}`;
  }

  let i = 0;

  if (filter?.vehicle_id) {
    path += `&filters[${i}][key]=vehicle_id&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter?.vehicle_id}`;
    ++i;
  }

  if (filter?.regplate) {
    path += `&filters[${i}][key]=regplate&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter.regplate}`;
    ++i;
  }

  if (filter?.type) {
    path += `&filters[${i}][key]=type&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter.type}`;
    ++i;
  }

  if (filter?.is_credit) {
    path += `&filters[${i}][key]=is_credit&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter.is_credit}`;
    ++i;
  }

  if (filter?.synced) {
    path += `&filters[${i}][key]=synced&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter.synced}`;
    ++i;
  }

  if (filter?.paid) {
    path += `&filters[${i}][key]=paid&filters[${i}][type]=single&filters[${i}][value][${i}]=${filter.paid}`;
    ++i;
  }

  yield put({
    type: GET_MY,
    id: REQUEST_INVOICES,
    work: REQUEST_INVOICES,
    gate: REQUEST_INVOICES,
    path,
  });
}

export function* invoicesSaga() {
  yield all([takeEvery(REQUEST_INVOICE_FILTER, requestInvoiceFilter)]);
}
